<script>
export default {
  name: "404"
};
</script>

<template>
  <h1>404</h1>
</template>
